import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import NewsTOPSliderSettings from "./NewsTOPSliderSettings";

import { useGetNews, useUpdateNews } from "../../../utils/useNews";
import { RequestState } from "../../../utils/RequestState";

const NewsTOPSliderSettingsContainer: React.FC = () => {
  const { newsData: news, newsLoading: isLoading } = useGetNews();
  const { updateNews, updateLoading, updateStatus } = useUpdateNews();
  const auth_token = useAppSelector(getAuthToken);

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  useEffect(() => {
    if (updateStatus === "success") setRequestState(RequestState.Success);
    if (updateStatus === "error") setRequestState(RequestState.Failed);

    setTimeout(() => setRequestState(RequestState.Waiting), 10000);
  }, [updateStatus]);

  useEffect(() => {
    if (!isLoading) {
      setNewsList([...news]);
    }
  }, [isLoading]);

  const [newsList, setNewsList] = useState<
    Array<{ id?: number; img: string | File; url: string; isExternal: boolean }>
  >([]);

  const addItem = () => {
    const n = newsList;
    n.unshift({ id: undefined, img: "", url: "", isExternal: false });
    setNewsList([...n]);
  };

  const removeItem = (index: number) => {
    const n = newsList.filter((v, i) => i !== index);
    setNewsList([...n]);
  };

  const handleInputChange = (
    index: number,
    value?: string | File | boolean
  ) => {
    if (value !== undefined) {
      const n = [...newsList];
      switch (typeof value) {
        case "string":
          n[index] = { ...n[index], url: value };
          setNewsList(n);
          break;
        case "boolean":
          n[index] = { ...n[index], isExternal: value };
          setNewsList(n);
          break;
        default:
          //img
          n[index] = { ...n[index], img: value };
          setNewsList(n);
          break;
      }
    } else {
      return null;
    }
  };

  const handleSubmit = () => {
    if (auth_token) {
      const news = [...newsList];
      const update_news: Array<{
        id?: number;
        img: number | File;
        url: string;
        isExternal: boolean;
      }> = [];

      news.map((el, i) => {
        if (typeof el.img === "string" && el.id) {
          update_news[i] = { ...el, img: el.id };
        } else if (el.img instanceof File) {
          update_news[i] = { ...el, img: el.img };
        }
      });

      updateNews({ auth_token: auth_token, news: update_news });
    }
  };

  return (
    <NewsTOPSliderSettings
      isLoading={isLoading || updateLoading}
      addItem={addItem}
      removeItem={removeItem}
      newsList={newsList}
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      requestState={requestState}
    />
  );
};

export default NewsTOPSliderSettingsContainer;
